<template>
  <!-- Phones: an editor's save action sits at the bottom of the screen and appears only once something has changed.
       Wider screens keep it in the page header (PageHeader's wide-only actions). -->
  <div v-if="dirty" class="sb" role="region" aria-label="Save changes">
    <span class="sb-note">Unsaved changes</span>
    <button type="button" class="pb-button" :disabled="saving" @click="$emit('save')">{{ saving ? 'Saving…' : 'Save changes' }}</button>
  </div>
</template>

<script>
export default {
  name: 'SaveBar',
  props: {
    dirty: { type: Boolean, default: false },
    saving: { type: Boolean, default: false }
  }
};
</script>

<style scoped>
.sb{display:none}
/* The page's last element: it sticks to the bottom of the screen while the page scrolls, and its negative margins
   take it edge to edge and down to the page's end. */
@media(max-width:600px){
  .sb{position:sticky;bottom:0;z-index:6;display:flex;align-items:center;justify-content:space-between;gap:12px;
    margin:24px -16px -64px;padding:12px 16px calc(12px + env(safe-area-inset-bottom));background:#fff;
    border-top:1px solid #E6DED2;box-shadow:0 -10px 28px rgba(60,42,24,.10)}
  .sb-note{font:600 14px/1.3 var(--font-body);color:#4F4A45}
}
</style>
